import { useChartContext } from '../../ChartContext';
import { QueryType } from '../../../../utils/apollo/graphqlSchema';
import BuilderInfo from '../../../BuilderInfo';
import EntityInfoPopover from '../../../EntityInfoPopover';

const ChartHeaderBuilderInfo = () => {
  const {
    metadata: { analysisId, queryType },
  } = useChartContext();

  if (
    queryType === QueryType.Prediction ||
    queryType === QueryType.CohortSample
  ) {
    return null;
  }

  return (
    <EntityInfoPopover closeOnAncestorScroll={true}>
      <BuilderInfo
        kind="report"
        analysisId={analysisId}
        queryType={queryType}
      />
    </EntityInfoPopover>
  );
};

export default ChartHeaderBuilderInfo;
